import React from "react"
import {ItemIconClass} from "../../../../gd/const/item-icon/icon/item-icon-class";
import {ItemIconSize} from "../../../../gd-components/icons/@const";
import CustomIcon from "../../../../gd-components/icons/common/custom-icon/custom-icon";
import {EmojiDict} from "../../../../gd/const/item-icon/emoji/emoji";
import Emoji from "../../../../gd-components/icons/common/emoji/emoji";
import {FieldViewProps} from "../../../render/view";

export default function FieldIcon_View(props: FieldViewProps) {

    const value = props.field.getViewValue(props.model)

    const iconSize = props.params?.size ? props.params.size : ItemIconSize.SIZE_14

    const classes = Classes("ui5-field-editable", props.className, {
        // "disabled": props.disabled,
    })

    const renderIcon = ()=> {

        if (value?.substring(0, 4) === 'url:') {
            return <CustomIcon size={iconSize} className={props.className} icon={value}/>
        }

        if (!!EmojiDict[value]) {

            // need add black and white fiulter when disabled ?
            const classes = Classes(props.className)

            return <Emoji name={value} className={classes} size={iconSize}/>
        }

        const iconClass = ItemIconClass[value]

        const iconClasses = Classes(iconClass, "ui5-ico-"+iconSize)

        return <div className={iconClasses}></div>
    }

    return (
        <>
            <div className={classes} onClick={props.onClick}>
                {renderIcon()}
            </div>
            {props.children}
        </>
    )
}
